export enum PostScheduleType {
	Posted = "posted",
	Scheduled = "scheduled",
	All = "all"
}
